var Pixel = Pixel || {};

Pixel.GTAG = (function (PixelBase) {

    var _GTAG = PixelBase.extend({
        initialize: function (opts) {

        },

        pageView: function () {

        },

        purchaseSuccess: function (opts) {
            opts = opts || {};
            var data = opts.OrderInfoResult;

            var da = data.DeliveryAddress || {};
            var userName = da.Name || '';

            var enhanced_conversion_data = {};

            data.Email && (enhanced_conversion_data.email = data.Email);
            da.Phone && (enhanced_conversion_data.phone_number = da.Phone);
            userName && (enhanced_conversion_data.first_name = userName.split(' ').slice(0, 1).join(' '));
            userName && (enhanced_conversion_data.last_name = userName.split(' ').slice(1).join(' '));

            if (da.AddressLines || da.City || da.State || da.Suburb || da.Postcode) {
                da.AddressLines && (enhanced_conversion_data.street = da.AddressLines);
                da.Suburb && (enhanced_conversion_data.city = da.Suburb || da.City);
                da.State && (enhanced_conversion_data.region = da.State);
                da.Postcode && (enhanced_conversion_data.postal_code = da.Postcode);
                GlobalSettings.Iso && (enhanced_conversion_data.country = GlobalSettings.Iso);
            }

            if (window.gtag_report_conversion) {
                gtag_report_conversion(data.Total, GlobalSettings.Currency, data.InvoiceNo, data.OrderID, enhanced_conversion_data);
            }
        }
    });

    return _GTAG;
})(Pixel.PixelBase);

!function (Pixel) {
    new Pixel.GTAG();
}(Pixel);
